import { jsx as u, jsxs as O, Fragment as J } from "react/jsx-runtime";
import * as n from "react";
import * as Pe from "react-dom";
import { u as ge, c as _, a as he } from "./index-D7uzFyzw.js";
import { P as I, c as _e, u as ne, d as xe } from "./index-Bud8rdvZ.js";
import { c as Ce } from "./index-BsL1G1kw.js";
import { B as Re, R as be, P as Se } from "./index-Bbj5DEcJ.js";
import { P as Ie } from "./index-B6DkbY8I.js";
import { u as X } from "./index-0ioNhtNM.js";
import { a as se } from "./index-BMQ7iO4X.js";
import { c as oe } from "./clsx-OuTLNxxd.js";
import "./button.types-BqgkEc5r.js";
import "./components/elements/button/iconButton/iconButton.js";
import { I as Fe } from "./icon-B72I4fRl.js";
import "./components/elements/icon/iconsList.js";
import "./components/elements/tag/tag.js";
import "./components/elements/carousel/carousel.js";
import { L as Ae } from "./link-CBjEeGbl.js";
import "./components/elements/inputs/input/input.js";
import "./components/elements/inputs/checkbox/checkbox.js";
import "./phoneNumber-5ohMfWd7.js";
import "./components/elements/inputs/dateRangePicker/dateRangePicker.js";
import "./components/elements/toast/toast.context.js";
import "./map-DjiAXeob.js";
import { Flex as De } from "./components/layout/flex/flex.js";
var Q = "ToastProvider", [Z, Ne, Le] = Ce("Toast"), [ae, Rt] = _e("Toast", [Le]), [Me, Y] = ae(Q), ie = (e) => {
  const {
    __scopeToast: o,
    label: r = "Notification",
    duration: t = 5e3,
    swipeDirection: c = "right",
    swipeThreshold: l = 50,
    children: p
  } = e, [w, v] = n.useState(null), [i, h] = n.useState(0), E = n.useRef(!1), F = n.useRef(!1);
  return r.trim() || console.error(
    `Invalid prop \`label\` supplied to \`${Q}\`. Expected non-empty \`string\`.`
  ), /* @__PURE__ */ u(Z.Provider, { scope: o, children: /* @__PURE__ */ u(
    Me,
    {
      scope: o,
      label: r,
      duration: t,
      swipeDirection: c,
      swipeThreshold: l,
      toastCount: i,
      viewport: w,
      onViewportChange: v,
      onToastAdd: n.useCallback(() => h((R) => R + 1), []),
      onToastRemove: n.useCallback(() => h((R) => R - 1), []),
      isFocusedToastEscapeKeyDownRef: E,
      isClosePausedRef: F,
      children: p
    }
  ) });
};
ie.displayName = Q;
var ce = "ToastViewport", Oe = ["F8"], q = "toast.viewportPause", z = "toast.viewportResume", ue = n.forwardRef(
  (e, o) => {
    const {
      __scopeToast: r,
      hotkey: t = Oe,
      label: c = "Notifications ({hotkey})",
      ...l
    } = e, p = Y(ce, r), w = Ne(r), v = n.useRef(null), i = n.useRef(null), h = n.useRef(null), E = n.useRef(null), F = ne(o, E, p.onViewportChange), R = t.join("+").replace(/Key/g, "").replace(/Digit/g, ""), b = p.toastCount > 0;
    n.useEffect(() => {
      const a = (y) => {
        t.length !== 0 && t.every((m) => y[m] || y.code === m) && E.current?.focus();
      };
      return document.addEventListener("keydown", a), () => document.removeEventListener("keydown", a);
    }, [t]), n.useEffect(() => {
      const a = v.current, y = E.current;
      if (b && a && y) {
        const f = () => {
          if (!p.isClosePausedRef.current) {
            const T = new CustomEvent(q);
            y.dispatchEvent(T), p.isClosePausedRef.current = !0;
          }
        }, m = () => {
          if (p.isClosePausedRef.current) {
            const T = new CustomEvent(z);
            y.dispatchEvent(T), p.isClosePausedRef.current = !1;
          }
        }, P = (T) => {
          !a.contains(T.relatedTarget) && m();
        }, g = () => {
          a.contains(document.activeElement) || m();
        };
        return a.addEventListener("focusin", f), a.addEventListener("focusout", P), a.addEventListener("pointermove", f), a.addEventListener("pointerleave", g), window.addEventListener("blur", f), window.addEventListener("focus", m), () => {
          a.removeEventListener("focusin", f), a.removeEventListener("focusout", P), a.removeEventListener("pointermove", f), a.removeEventListener("pointerleave", g), window.removeEventListener("blur", f), window.removeEventListener("focus", m);
        };
      }
    }, [b, p.isClosePausedRef]);
    const d = n.useCallback(
      ({ tabbingDirection: a }) => {
        const f = w().map((m) => {
          const P = m.ref.current, g = [P, ...Je(P)];
          return a === "forwards" ? g : g.reverse();
        });
        return (a === "forwards" ? f.reverse() : f).flat();
      },
      [w]
    );
    return n.useEffect(() => {
      const a = E.current;
      if (a) {
        const y = (f) => {
          const m = f.altKey || f.ctrlKey || f.metaKey;
          if (f.key === "Tab" && !m) {
            const g = document.activeElement, T = f.shiftKey;
            if (f.target === a && T) {
              i.current?.focus();
              return;
            }
            const D = d({ tabbingDirection: T ? "backwards" : "forwards" }), V = D.findIndex((S) => S === g);
            j(D.slice(V + 1)) ? f.preventDefault() : T ? i.current?.focus() : h.current?.focus();
          }
        };
        return a.addEventListener("keydown", y), () => a.removeEventListener("keydown", y);
      }
    }, [w, d]), /* @__PURE__ */ O(
      Re,
      {
        ref: v,
        role: "region",
        "aria-label": c.replace("{hotkey}", R),
        tabIndex: -1,
        style: { pointerEvents: b ? void 0 : "none" },
        children: [
          b && /* @__PURE__ */ u(
            G,
            {
              ref: i,
              onFocusFromOutsideViewport: () => {
                const a = d({
                  tabbingDirection: "forwards"
                });
                j(a);
              }
            }
          ),
          /* @__PURE__ */ u(Z.Slot, { scope: r, children: /* @__PURE__ */ u(I.ol, { tabIndex: -1, ...l, ref: F }) }),
          b && /* @__PURE__ */ u(
            G,
            {
              ref: h,
              onFocusFromOutsideViewport: () => {
                const a = d({
                  tabbingDirection: "backwards"
                });
                j(a);
              }
            }
          )
        ]
      }
    );
  }
);
ue.displayName = ce;
var le = "ToastFocusProxy", G = n.forwardRef(
  (e, o) => {
    const { __scopeToast: r, onFocusFromOutsideViewport: t, ...c } = e, l = Y(le, r);
    return /* @__PURE__ */ u(
      se,
      {
        tabIndex: 0,
        ...c,
        ref: o,
        style: { position: "fixed" },
        onFocus: (p) => {
          const w = p.relatedTarget;
          !l.viewport?.contains(w) && t();
        }
      }
    );
  }
);
G.displayName = le;
var k = "Toast", ke = "toast.swipeStart", Ke = "toast.swipeMove", Ve = "toast.swipeCancel", He = "toast.swipeEnd", de = n.forwardRef(
  (e, o) => {
    const { forceMount: r, open: t, defaultOpen: c, onOpenChange: l, ...p } = e, [w, v] = ge({
      prop: t,
      defaultProp: c ?? !0,
      onChange: l,
      caller: k
    });
    return /* @__PURE__ */ u(Ie, { present: r || w, children: /* @__PURE__ */ u(
      Ue,
      {
        open: w,
        ...p,
        ref: o,
        onClose: () => v(!1),
        onPause: X(e.onPause),
        onResume: X(e.onResume),
        onSwipeStart: _(e.onSwipeStart, (i) => {
          i.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: _(e.onSwipeMove, (i) => {
          const { x: h, y: E } = i.detail.delta;
          i.currentTarget.setAttribute("data-swipe", "move"), i.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${h}px`), i.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${E}px`);
        }),
        onSwipeCancel: _(e.onSwipeCancel, (i) => {
          i.currentTarget.setAttribute("data-swipe", "cancel"), i.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), i.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), i.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), i.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: _(e.onSwipeEnd, (i) => {
          const { x: h, y: E } = i.detail.delta;
          i.currentTarget.setAttribute("data-swipe", "end"), i.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), i.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), i.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${h}px`), i.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${E}px`), v(!1);
        })
      }
    ) });
  }
);
de.displayName = k;
var [We, $e] = ae(k, {
  onClose() {
  }
}), Ue = n.forwardRef(
  (e, o) => {
    const {
      __scopeToast: r,
      type: t = "foreground",
      duration: c,
      open: l,
      onClose: p,
      onEscapeKeyDown: w,
      onPause: v,
      onResume: i,
      onSwipeStart: h,
      onSwipeMove: E,
      onSwipeCancel: F,
      onSwipeEnd: R,
      ...b
    } = e, d = Y(k, r), [a, y] = n.useState(null), f = ne(o, (s) => y(s)), m = n.useRef(null), P = n.useRef(null), g = c || d.duration, T = n.useRef(0), A = n.useRef(g), K = n.useRef(0), { onToastAdd: D, onToastRemove: V } = d, S = X(() => {
      a?.contains(document.activeElement) && d.viewport?.focus(), p();
    }), H = n.useCallback(
      (s) => {
        !s || s === 1 / 0 || (window.clearTimeout(K.current), T.current = (/* @__PURE__ */ new Date()).getTime(), K.current = window.setTimeout(S, s));
      },
      [S]
    );
    n.useEffect(() => {
      const s = d.viewport;
      if (s) {
        const x = () => {
          H(A.current), i?.();
        }, C = () => {
          const N = (/* @__PURE__ */ new Date()).getTime() - T.current;
          A.current = A.current - N, window.clearTimeout(K.current), v?.();
        };
        return s.addEventListener(q, C), s.addEventListener(z, x), () => {
          s.removeEventListener(q, C), s.removeEventListener(z, x);
        };
      }
    }, [d.viewport, g, v, i, H]), n.useEffect(() => {
      l && !d.isClosePausedRef.current && H(g);
    }, [l, g, d.isClosePausedRef, H]), n.useEffect(() => (D(), () => V()), [D, V]);
    const ee = n.useMemo(() => a ? Te(a) : null, [a]);
    return d.viewport ? /* @__PURE__ */ O(J, { children: [
      ee && /* @__PURE__ */ u(
        Xe,
        {
          __scopeToast: r,
          role: "status",
          "aria-live": t === "foreground" ? "assertive" : "polite",
          children: ee
        }
      ),
      /* @__PURE__ */ u(We, { scope: r, onClose: S, children: Pe.createPortal(
        /* @__PURE__ */ u(Z.ItemSlot, { scope: r, children: /* @__PURE__ */ u(
          be,
          {
            asChild: !0,
            onEscapeKeyDown: _(w, () => {
              d.isFocusedToastEscapeKeyDownRef.current || S(), d.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ u(
              I.li,
              {
                tabIndex: 0,
                "data-state": l ? "open" : "closed",
                "data-swipe-direction": d.swipeDirection,
                ...b,
                ref: f,
                style: { userSelect: "none", touchAction: "none", ...e.style },
                onKeyDown: _(e.onKeyDown, (s) => {
                  s.key === "Escape" && (w?.(s.nativeEvent), s.nativeEvent.defaultPrevented || (d.isFocusedToastEscapeKeyDownRef.current = !0, S()));
                }),
                onPointerDown: _(e.onPointerDown, (s) => {
                  s.button === 0 && (m.current = { x: s.clientX, y: s.clientY });
                }),
                onPointerMove: _(e.onPointerMove, (s) => {
                  if (!m.current) return;
                  const x = s.clientX - m.current.x, C = s.clientY - m.current.y, N = !!P.current, L = ["left", "right"].includes(d.swipeDirection), W = ["left", "up"].includes(d.swipeDirection) ? Math.min : Math.max, Ee = L ? W(0, x) : 0, ye = L ? 0 : W(0, C), B = s.pointerType === "touch" ? 10 : 2, $ = { x: Ee, y: ye }, te = { originalEvent: s, delta: $ };
                  N ? (P.current = $, U(Ke, E, te, {
                    discrete: !1
                  })) : re($, d.swipeDirection, B) ? (P.current = $, U(ke, h, te, {
                    discrete: !1
                  }), s.target.setPointerCapture(s.pointerId)) : (Math.abs(x) > B || Math.abs(C) > B) && (m.current = null);
                }),
                onPointerUp: _(e.onPointerUp, (s) => {
                  const x = P.current, C = s.target;
                  if (C.hasPointerCapture(s.pointerId) && C.releasePointerCapture(s.pointerId), P.current = null, m.current = null, x) {
                    const N = s.currentTarget, L = { originalEvent: s, delta: x };
                    re(x, d.swipeDirection, d.swipeThreshold) ? U(He, R, L, {
                      discrete: !0
                    }) : U(
                      Ve,
                      F,
                      L,
                      {
                        discrete: !0
                      }
                    ), N.addEventListener("click", (W) => W.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        d.viewport
      ) })
    ] }) : null;
  }
), Xe = (e) => {
  const { __scopeToast: o, children: r, ...t } = e, c = Y(k, o), [l, p] = n.useState(!1), [w, v] = n.useState(!1);
  return ze(() => p(!0)), n.useEffect(() => {
    const i = window.setTimeout(() => v(!0), 1e3);
    return () => window.clearTimeout(i);
  }, []), w ? null : /* @__PURE__ */ u(Se, { asChild: !0, children: /* @__PURE__ */ u(se, { ...t, children: l && /* @__PURE__ */ O(J, { children: [
    c.label,
    " ",
    r
  ] }) }) });
}, Ye = "ToastTitle", Be = n.forwardRef(
  (e, o) => {
    const { __scopeToast: r, ...t } = e;
    return /* @__PURE__ */ u(I.div, { ...t, ref: o });
  }
);
Be.displayName = Ye;
var je = "ToastDescription", pe = n.forwardRef(
  (e, o) => {
    const { __scopeToast: r, ...t } = e;
    return /* @__PURE__ */ u(I.div, { ...t, ref: o });
  }
);
pe.displayName = je;
var fe = "ToastAction", qe = n.forwardRef(
  (e, o) => {
    const { altText: r, ...t } = e;
    return r.trim() ? /* @__PURE__ */ u(ve, { altText: r, asChild: !0, children: /* @__PURE__ */ u(we, { ...t, ref: o }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${fe}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
qe.displayName = fe;
var me = "ToastClose", we = n.forwardRef(
  (e, o) => {
    const { __scopeToast: r, ...t } = e, c = $e(me, r);
    return /* @__PURE__ */ u(ve, { asChild: !0, children: /* @__PURE__ */ u(
      I.button,
      {
        type: "button",
        ...t,
        ref: o,
        onClick: _(e.onClick, c.onClose)
      }
    ) });
  }
);
we.displayName = me;
var ve = n.forwardRef((e, o) => {
  const { __scopeToast: r, altText: t, ...c } = e;
  return /* @__PURE__ */ u(
    I.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": t || void 0,
      ...c,
      ref: o
    }
  );
});
function Te(e) {
  const o = [];
  return Array.from(e.childNodes).forEach((t) => {
    if (t.nodeType === t.TEXT_NODE && t.textContent && o.push(t.textContent), Ge(t)) {
      const c = t.ariaHidden || t.hidden || t.style.display === "none", l = t.dataset.radixToastAnnounceExclude === "";
      if (!c)
        if (l) {
          const p = t.dataset.radixToastAnnounceAlt;
          p && o.push(p);
        } else
          o.push(...Te(t));
    }
  }), o;
}
function U(e, o, r, { discrete: t }) {
  const c = r.originalEvent.currentTarget, l = new CustomEvent(e, { bubbles: !0, cancelable: !0, detail: r });
  o && c.addEventListener(e, o, { once: !0 }), t ? xe(c, l) : c.dispatchEvent(l);
}
var re = (e, o, r = 0) => {
  const t = Math.abs(e.x), c = Math.abs(e.y), l = t > c;
  return o === "left" || o === "right" ? l && t > r : !l && c > r;
};
function ze(e = () => {
}) {
  const o = X(e);
  he(() => {
    let r = 0, t = 0;
    return r = window.requestAnimationFrame(() => t = window.requestAnimationFrame(o)), () => {
      window.cancelAnimationFrame(r), window.cancelAnimationFrame(t);
    };
  }, [o]);
}
function Ge(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function Je(e) {
  const o = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (t) => {
      const c = t.tagName === "INPUT" && t.type === "hidden";
      return t.disabled || t.hidden || c ? NodeFilter.FILTER_SKIP : t.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) o.push(r.currentNode);
  return o;
}
function j(e) {
  const o = document.activeElement;
  return e.some((r) => r === o ? !0 : (r.focus(), document.activeElement !== o));
}
var bt = ie, Qe = ue, Ze = de, et = pe;
const tt = "_toast_1lsgn_29", ot = "_viewport_1lsgn_67", M = {
  toast: tt,
  "is-success": "_is-success_1lsgn_41",
  "is-error": "_is-error_1lsgn_44",
  "is-warning": "_is-warning_1lsgn_47",
  "is-static": "_is-static_1lsgn_50",
  "slide-in": "_slide-in_1lsgn_1",
  "fade-out": "_fade-out_1lsgn_1",
  "swipe-out": "_swipe-out_1lsgn_1",
  viewport: ot,
  "dialog-overlay-show": "_dialog-overlay-show_1lsgn_1",
  "dialog-content-show": "_dialog-content-show_1lsgn_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1lsgn_1"
};
function St({ status: e, text: o, open: r, link: t, onOpenChange: c, isStatic: l = !1 }) {
  return /* @__PURE__ */ O(J, { children: [
    /* @__PURE__ */ u(
      Ze,
      {
        className: oe(M.toast, M[`is-${e}`], l && M["is-static"]),
        open: r,
        onOpenChange: c,
        type: "foreground",
        children: /* @__PURE__ */ u(et, { children: /* @__PURE__ */ O(De, { alignItems: "center", gap: "2", flexWrap: "nowrap", children: [
          /* @__PURE__ */ u(Fe, { color: e, name: e === "success" ? "checkbox-fill" : "error-warning-fill" }),
          o,
          t && /* @__PURE__ */ u(Ae, { ...t })
        ] }) })
      }
    ),
    /* @__PURE__ */ u(Qe, { className: oe(M.viewport, l && M["is-static"]) })
  ] });
}
export {
  bt as P,
  St as T
};
